(() => {
  if (window.ggLocalizationReady) return;
  window.ggLocalizationReady = true;
  document.addEventListener('change', (event) => {
    const select = event.target.closest('.gg-localization select');
    if (!select?.form) return;
    select.form.requestSubmit();
  });
})();
